import { useEffect, useState } from 'react';
import BouncingCircles from './components/BouncingCircles';
import useInViewOnce from '../../hooks/useInViewOnce';
import { getBrands } from '../../services/brands';
import leoraIcon from '../../assets/leoraIcon.png';
import aboutImg1 from '../../assets/home/imag1.jpg';
import aboutImg2 from '../../assets/home/imag2.jpg';
import './Home.css';

function Home() {
  const [brands, setBrands] = useState([]);
  const [aboutRef, aboutInView] = useInViewOnce();

  useEffect(() => {
    getBrands()
      .then(setBrands)
      .catch((err) => console.error('Error cargando marcas:', err));
  }, []);

  return (
    <div className="home-page">
      {/* Hero + Marcas rebotando de fondo — primer viewport */}
      <section className="home-hero-viewport">
        <BouncingCircles brands={brands} />
        <div className="home-hero-overlay">
          <div className="home-hero-content">
            <h1 className="home-hero-title">
              <img src={leoraIcon} alt="Leora" className="home-hero-logo" />
            </h1>
            <a href="/productos" className="home-hero-cta">
              Ver catálogo
            </a>
          </div>
        </div>
      </section>

      {/* Historia / About — zigzag: texto|img → img|texto */}
      <section
        ref={aboutRef}
        className={`home-section home-about${aboutInView ? ' is-inview' : ''}`}
      >
        <div className="home-about-content">
          <h2
            className={`home-section-title sf-reveal${aboutInView ? ' is-inview' : ''}`}
          >
            Nuestra Historia
          </h2>

          <div className="home-about-row">
            <div
              className={`home-about-text sf-reveal${aboutInView ? ' is-inview' : ''}`}
            >
              <p>
                Desde niña supe que quería crear. Trenzas, stickers, ideas que nacían
                del juego y el deseo de ser algo más. Con los años la vida me puso
                pruebas. Pasé por una etapa que me llevó a cuestionarlo todo. Mi
                cuerpo, mi valor, mi lugar.
              </p>
              <p>
                Pero también fue ahí donde aprendí algo esencial: que lo que veo en
                él también enseña. Empecé desde cero, más de una vez. Trabajé, vendí,
                busqué oportunidades y encontré fuerzas abiertas a mi alma.
              </p>
            </div>
            <img
              src={aboutImg1}
              alt="Léora — nuestra historia"
              className={`home-about-img sf-reveal sf-reveal-delay-2${aboutInView ? ' is-inview' : ''}`}
            />
          </div>

          <div className="home-about-row home-about-row--flip">
            <img
              src={aboutImg2}
              alt="Léora — nuestra historia"
              className={`home-about-img sf-reveal sf-reveal-delay-2${aboutInView ? ' is-inview' : ''}`}
            />
            <div
              className={`home-about-text sf-reveal sf-reveal-delay-3${aboutInView ? ' is-inview' : ''}`}
            >
              <p>
                Así nació <strong>Leora</strong>. De la niña inquieta, de la mujer
                que se reconstruyó, de una profesional que decidió creer en ella
                misma. Hoy, Leora no es solo una marca de maquillaje — es una forma
                de ver la belleza.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
